export const BREAKFAST = 'breakfast';
export const DINNER = 'dinner';
export const SNACK = 'snack';
export const LUNCH = 'lunch';

export const mealsOrder = [
  BREAKFAST,
  LUNCH,
  SNACK,
  DINNER,
];